// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"3ee5c13a","453":"d9e4fa0a","754":"8747cd87","865":"328540f8"}[chunkId] + ".chunk.js";
};